import { createReducer } from "@reduxjs/toolkit";

// Define the initial state
const initialState = {
    loading: false,
    enrolledCoursesLoading: false,
    error: {},      // To handle errors
    timeSlots: [],  // To store fetched time slots
    courseSideTimeSlots : [],
    enrolledCourseTimeTable : [],
    enrolledCoursePackageFields: "",
    enrolledStudentPickupServiceOffer:"",
    enrolledStudentUpdateLocationRequest:"",
    coursePaymentDetailsData : [],
    coursePaymentInstallmentInvoiceData : "",
    courseCourseCertificateData : "",
    CertificateIdData : "",
    certificateLinkData : "",
    InstituteCourseStep1Id : "",
    InstituteAutomaticTrainingHours: "",  // To store fetched time slots
    AdminCourse: null,  // Single course for view/edit
    AdminCourses: [],   // List of all courses
    pagination: null,   // Pagination metadata
};




export const CourseReducer = createReducer(initialState, (builder) => {

    builder.addCase("CourseRequest", (state, action) => {
        const nextId = action.payload?.InstituteCourseId;
        const sameCourse =
            nextId != null &&
            String(state.CourseInfo?.InstituteCourseId) === String(nextId);
        if (!sameCourse) {
            state.loading = true;
            state.CourseInfo = undefined;
        }
    });

    builder.addCase("CourseSuccess", (state, action) => {
        state.loading = false;
        state.error = {}
        state.CourseInfo = action.payload;
    })

    builder.addCase('CourseFailure', (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })



    builder.addCase("GetAdminCoursesRequest", (state, action) => {
        state.loading = true
    });

    builder.addCase("GetAdminCoursesSuccess", (state, action) => {
        state.loading = false;
        state.error = {}
        // Handle paginated response format
        state.AdminCourses = action.payload.courses || action.payload;
        state.pagination = action.payload.pagination || null;
    })

    builder.addCase('GetAdminCoursesFailure', (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })

    // Get Single Admin Course (for View/Edit)
    builder.addCase("GetAdminCourseRequest", (state, action) => {
        state.loading = true
    });

    builder.addCase("GetAdminCourseSuccess", (state, action) => {
        state.loading = false;
        state.error = {}
        state.AdminCourse = action.payload;
    })

    builder.addCase('GetAdminCourseFailure', (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })

    // Clear Admin Course
    builder.addCase('ClearAdminCourse', (state) => {
        state.AdminCourse = null;
    })

    // Update Admin Course in list (when course is updated)
    builder.addCase("Admin_UpdateCourseSuccess", (state, action) => {
        const updatedCourse = action.payload;
        if (updatedCourse && updatedCourse.CoursePK) {
            // Find and update the course in AdminCourses list
            const courseIndex = state.AdminCourses.findIndex(course => 
                course.CoursePK === updatedCourse.CoursePK || course.id === updatedCourse.CoursePK
            );
            if (courseIndex !== -1) {
                state.AdminCourses[courseIndex] = { ...state.AdminCourses[courseIndex], ...updatedCourse };
            }
            // Also update AdminCourse if it's the same course
            if (state.AdminCourse && (state.AdminCourse.CoursePK === updatedCourse.CoursePK || state.AdminCourse.id === updatedCourse.CoursePK)) {
                state.AdminCourse = { ...state.AdminCourse, ...updatedCourse };
            }
        }
    })







    builder.addCase("BuyCourseRequest", (state, action) => {
        state.loading = true;
    })

    builder.addCase("BuyCourseSuccess", (state, action) => {
        state.loading = false;
        state.error = {}
        state.CourseInfo = action.payload;
    })

    builder.addCase("BuyCoursefailure", (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })

    // Admin Enroll Learner
    builder.addCase("AdminEnrollLearnerRequest", (state) => {
        state.loading = true;
        state.error = {};
    });

    builder.addCase("AdminEnrollLearnerSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
        state.AdminEnrollmentRequest = action.payload;
    });

    builder.addCase("AdminEnrollLearnerFailure", (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })





    builder.addCase("EnrollCourseRequest", (state, action) => {
        const nextId = action.payload?.InstituteCourseId;
        const sameCourse =
            nextId != null &&
            String(state.EnrollCourseInfo?.InstituteCourseId) === String(nextId);
        if (!sameCourse) {
            state.loading = true;
            state.EnrollCourseInfo = undefined;
        }
    });

    builder.addCase("EnrollCourseSuccess", (state, action) => {
        state.loading = false;
        state.error = {}
        state.EnrollCourseInfo = action.payload;
    })

    builder.addCase('EnrollCourseFailure', (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })





    builder.addCase("GetEnrolledCoursesRequest", (state, action) => {
        state.enrolledCoursesLoading = true
    });

    builder.addCase("GetEnrolledCoursesSuccess", (state, action) => {
        state.enrolledCoursesLoading = false;
        state.error = {}
        state.EnrolledCourses = action.payload;
    })

    builder.addCase('GetEnrolledCoursesFailure', (state, action) => {
        state.enrolledCoursesLoading = false;
        state.error = action.payload;
    })






    builder.addCase("GetSEnrolledCoursesRequest", (state, action) => {
        state.loading = true
    });

    builder.addCase("GetSEnrolledCoursesSuccess", (state, action) => {
        state.loading = false;
        state.error = {}
        state.SEnrolledCourse = action.payload;
    })

    builder.addCase('GetSEnrolledCoursesFailure', (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })

    //get enrolled student time table
    builder.addCase("GetSEnrolledCourseTimeTableRequest", (state, action) => {
        state.loading = true
    });

    builder.addCase("GetSEnrolledCourseTimeTableRequestSuccess", (state, action) => {
        state.loading = false;
        state.error = {}
        state.enrolledCourseTimeTable = action.payload;
    })

    builder.addCase('GetSEnrolledCourseTimeTableRequestFailure', (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })

    //get enrolled student Pickup Service Offers
    builder.addCase("GetSEnrolledPickupServiceOffersRequest", (state, action) => {
        state.loading = true
    });

    builder.addCase("GetSEnrolledPickupServiceOffersSuccess", (state, action) => {
        state.loading = false;
        state.error = {}
        state.enrolledStudentPickupServiceOffer = action.payload;
    })

    builder.addCase('GetSEnrolledPickupServiceOffersFailure', (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })

     //get enrolled student update pickup location 
     builder.addCase("GetSEnrolledStudentUpdatePickupLocationRequest", (state, action) => {
        state.loading = true
    });

    builder.addCase("GetSEnrolledStudentUpdatePickupLocationSuccess", (state, action) => {
        state.loading = false;
        state.error = {}
        state.enrolledStudentUpdateLocationRequest = action.payload;
    })

    builder.addCase('GetSEnrolledStudentUpdatePickupLocationFailure', (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })

    //get enrolled student Course Package Fields
    builder.addCase("GetSEnrolledStudentCoursePackageFieldsRequest", (state, action) => {
        state.loading = true
    });

    builder.addCase("GetSEnrolledStudentCoursePackageFieldsSuccess", (state, action) => {
        state.loading = false;
        state.error = {}
        state.enrolledCoursePackageFields = action.payload;
    })

    builder.addCase('GetSEnrolledStudentCoursePackageFieldsFailure', (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })

    //get enrolled student Course Package Fields
    builder.addCase("UpdateEnrolledStudentPickupServiceStatusRequest", (state, action) => {
        state.loading = true
    });

    builder.addCase("UpdateEnrolledStudentPickupServiceStatusSuccess", (state, action) => {
        state.loading = false;
        state.error = {}
    })

    builder.addCase('UpdateEnrolledStudentPickupServiceStatusFailure', (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })

    builder.addCase("LicenceTypeCoursesRequest", (state, action) => {
        state.loading = true
    })

    builder.addCase("LicenceTypeCoursesSuccess", (state, action) => {
        state.loading = false;
        state.error = {}
        state.Courses = action.payload;
    })
    builder.addCase("LicenceTypeCoursesFailure", (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })




    builder.addCase("EnrolledCourseProgressRequest", (state, action) => {
        state.loading = true
    })

    builder.addCase("EnrolledCourseProgressSuccess", (state, action) => {
        state.loading = false;
        state.error = {}
        state.CourseProgress = action.payload;
    })
    builder.addCase("EnrolledCourseProgressFailure", (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })




    builder.addCase("CreateCourseRequest", (state, action) => {
        state.loading = true
    })

    builder.addCase("CreateCourseSuccess", (state, action) => {
        state.loading = false;
        state.error = {}
        state.Course = action.payload;
    })
    builder.addCase("CreateCourseFailure", (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })



    builder.addCase("FilterCoursesRequest", (state, action) => {
        state.loading = true
    })

    builder.addCase("FilterCoursesSuccess", (state, action) => {
        state.loading = false;
        state.error = {}
        state.AdminCourses = action.payload;
    })
    builder.addCase("FilterCoursesFailure", (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })



    builder.addCase("GetInstituteCoursesRequest", (state, action) => {
        state.loading = true
    })

    builder.addCase("GetInstituteCoursesSuccess", (state, action) => {
        state.loading = false;
        state.error = {}
        state.Courses = action.payload;
    })
    builder.addCase("GetInstituteCoursesFailure", (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })


    builder.addCase("GetInstitutePendingCoursesRequest", (state, action) => {
        state.loading = true
    })

    builder.addCase("GetInstitutePendingCoursesSuccess", (state, action) => {
        state.loading = false;
        state.error = {}
        state.PendingCourses = action.payload;
    })
    builder.addCase("GetInstitutePendingCoursesFailure", (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })


    builder.addCase("GetInstituteCoursesCountRequest", (state, action) => {
        state.loading = true
    })

    builder.addCase("GetInstituteCoursesCountSuccess", (state, action) => {
        state.loading = false;
        state.error = {}
        state.CoursesCount = action.payload;
    })
    builder.addCase("GetInstituteCoursesCountFailure", (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })




    builder.addCase("GetInstituteCoursesTimeSlotsRequest", (state, action) => {
        state.loading = true
    })

    builder.addCase("GetInstituteCoursesTimeSlotsSuccess", (state, action) => {
        state.loading = false;
        state.error = {}
        state.timeSlots = action.payload; // Store fetched time slots
    })
    builder.addCase("GetInstituteCoursesTimeSlotsFailure", (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })




    builder.addCase("GetInstituteSideCoursesTimeSlotsRequest", (state, action) => {
        state.loading = true
    })

    builder.addCase("GetInstituteSideCoursesTimeSlotsSuccess", (state, action) => {
        state.loading = false;
        state.error = {}
        state.courseSideTimeSlots = action.payload; // Store fetched time slots
    })
    builder.addCase("GetInstituteSideCoursesTimeSlotsFailure", (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })

     //GetCoursePaymentDetails reducers
     builder.addCase("GetCoursePaymentDetailsRequest", (state, action) => {
        state.loading = true
    });

    builder.addCase("GetCoursePaymentDetailsSuccess", (state, action) => {
        state.loading = false;
        state.error = {}
        state.coursePaymentDetailsData = action.payload; // Store fetched time slots
    })

    builder.addCase('GetCoursePaymentDetailsFailure', (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })

    //GetPaymentInvoiceData reducers
    builder.addCase("GetPaymentInvoiceDataRequest", (state, action) => {
        state.loading = true
    });

    builder.addCase("GetPaymentInvoiceDataSuccess", (state, action) => {
        state.loading = false;
        state.error = {}
        state.coursePaymentInstallmentInvoiceData = action.payload; // Store fetched time slots
    })

    builder.addCase('GetPaymentInvoiceDataFailure', (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })

    //GetCourseCertificateData reducers
    builder.addCase("GetCourseCertificateDataRequest", (state, action) => {
        state.loading = true
    });

    builder.addCase("GetCourseCertificateDataSuccess", (state, action) => {
        state.loading = false;
        state.error = {}
        state.courseCourseCertificateData = action.payload; // Store fetched time slots
    })

    builder.addCase('GetCourseCertificateDataFailure', (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })

    //GetEnrollmentFKfromCertificateId reducers
    builder.addCase("GetEnrollmentFKfromCertificateIdRequest", (state, action) => {
        state.loading = true
    });

    builder.addCase("GetEnrollmentFKfromCertificateIdSuccess", (state, action) => {
        state.loading = false;
        state.error = {}
        state.CertificateIdData = action.payload; // Store fetched time slots
    })

    builder.addCase('GetEnrollmentFKfromCertificateIdFailure', (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })

     //VerifyCerificateData reducers
     builder.addCase("VerifyCerificateDataRequest", (state, action) => {
        state.loading = true
    });

    builder.addCase("VerifyCerificateDataSuccess", (state, action) => {
        state.loading = false;
        state.error = {}
        state.certificateLinkData = action.payload; // Store fetched time slots
    })

    builder.addCase('VerifyCerificateDataFailure', (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })

    builder.addCase("CreateInstituteCourseStep1Request", (state, action) => {
        state.loading = true
    })

    builder.addCase("CreateInstituteCourseStep1Success", (state, action) => {
        state.loading = false;
        state.error = {}
        state.InstituteCourseStep1Id = action.payload;
    })
    builder.addCase("CreateInstituteCourseStep1Failure", (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })

    builder.addCase("CreateInstituteCourseStep2Request", (state, action) => {
        state.loading = true
    })

    builder.addCase("CreateInstituteCourseStep2Success", (state, action) => {
        state.loading = false;
        state.error = {}
    })
    builder.addCase("CreateInstituteCourseStep2Failure", (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })

    builder.addCase("DeleteInstituteCourseRequest", (state, action) => {
        state.loading = true
    })

    builder.addCase("DeleteInstituteCourseSuccess", (state, action) => {
        state.loading = false;
        state.error = {}
    })
    builder.addCase("DeleteInstituteCourseFailure", (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })


    builder.addCase("GetInstituteAutomaticTrainingHoursGenerationRequest", (state, action) => {
        state.loading = true
    })

    builder.addCase("GetInstituteAutomaticTrainingHoursGenerationSuccess", (state, action) => {
        state.loading = false;
        state.error = {}
        state.InstituteAutomaticTrainingHours = action.payload; // Store fetched time slots
    })
    builder.addCase("GetInstituteAutomaticTrainingHoursGenerationFailure", (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })
})




    // builder.addCase("EnrolledCourseProgressSuccess", (state, action) => {

    //     state.loading = false;

    //     state.error = {}

    //     state.CourseProgress = action.payload;

    // })

    // builder.addCase("EnrolledCourseProgressFailure", (state, action) => {

    //     state.loading = false;

    //     state.error = action.payload;

    // })









    // builder.addCase("CreateCourseRequest", (state, action) => {

    //     state.loading = true

    // })



    // builder.addCase("CreateCourseSuccess", (state, action) => {

    //     state.loading = false;

    //     state.error = {}

    //     state.Course = action.payload;

    // })

    // builder.addCase("CreateCourseFailure", (state, action) => {

    //     state.loading = false;

    //     state.error = action.payload;

    // })







    // builder.addCase("FilterCoursesRequest", (state, action) => {

    //     state.loading = true

    // })



    // builder.addCase("FilterCoursesSuccess", (state, action) => {

    //     state.loading = false;

    //     state.error = {}

    //     state.AdminCourses = action.payload;

    // })

    // builder.addCase("FilterCoursesFailure", (state, action) => {

    //     state.loading = false;

    //     state.error = action.payload;

    // })







    // builder.addCase("GetInstituteCoursesRequest", (state, action) => {

    //     state.loading = true

    // })



    // builder.addCase("GetInstituteCoursesSuccess", (state, action) => {

    //     state.loading = false;

    //     state.error = {}

    //     state.Courses = action.payload;

    // })

    // builder.addCase("GetInstituteCoursesFailure", (state, action) => {

    //     state.loading = false;

    //     state.error = action.payload;

    // })





    // builder.addCase("GetInstitutePendingCoursesRequest", (state, action) => {

    //     state.loading = true

    // })



    // builder.addCase("GetInstitutePendingCoursesSuccess", (state, action) => {

    //     state.loading = false;

    //     state.error = {}

    //     state.PendingCourses = action.payload;

    // })

    // builder.addCase("GetInstitutePendingCoursesFailure", (state, action) => {

    //     state.loading = false;

    //     state.error = action.payload;

    // })





    // builder.addCase("GetInstituteCoursesCountRequest", (state, action) => {

    //     state.loading = true

    // })



    // builder.addCase("GetInstituteCoursesCountSuccess", (state, action) => {

    //     state.loading = false;

    //     state.error = {}

    //     state.CoursesCount = action.payload;

    // })

    // builder.addCase("GetInstituteCoursesCountFailure", (state, action) => {

    //     state.loading = false;

    //     state.error = action.payload;

    // })









    // builder.addCase("GetInstituteCoursesTimeSlotsRequest", (state, action) => {

    //     state.loading = true

    // })



    // builder.addCase("GetInstituteCoursesTimeSlotsSuccess", (state, action) => {

    //     state.loading = false;

    //     state.error = {}

    //     state.timeSlots = action.payload; // Store fetched time slots

    // })

    // builder.addCase("GetInstituteCoursesTimeSlotsFailure", (state, action) => {

    //     state.loading = false;

    //     state.error = action.payload;

    // })









    // builder.addCase("GetInstituteSideCoursesTimeSlotsRequest", (state, action) => {

    //     state.loading = true

    // })



    // builder.addCase("GetInstituteSideCoursesTimeSlotsSuccess", (state, action) => {

    //     state.loading = false;

    //     state.error = {}

    //     state.courseSideTimeSlots = action.payload; // Store fetched time slots

    // })

    // builder.addCase("GetInstituteSideCoursesTimeSlotsFailure", (state, action) => {

    //     state.loading = false;

    //     state.error = action.payload;

    // })



    //  //GetCoursePaymentDetails reducers

    //  builder.addCase("GetCoursePaymentDetailsRequest", (state, action) => {

    //     state.loading = true

    // });



    // builder.addCase("GetCoursePaymentDetailsSuccess", (state, action) => {

    //     state.loading = false;

    //     state.error = {}

    //     state.coursePaymentDetailsData = action.payload; // Store fetched time slots

    // })



    // builder.addCase('GetCoursePaymentDetailsFailure', (state, action) => {

    //     state.loading = false;

    //     state.error = action.payload;

    // })



    // //GetPaymentInvoiceData reducers

    // builder.addCase("GetPaymentInvoiceDataRequest", (state, action) => {

    //     state.loading = true

    // });



    // builder.addCase("GetPaymentInvoiceDataSuccess", (state, action) => {

    //     state.loading = false;

    //     state.error = {}

    //     state.coursePaymentInstallmentInvoiceData = action.payload; // Store fetched time slots

    // })



    // builder.addCase('GetPaymentInvoiceDataFailure', (state, action) => {

    //     state.loading = false;

    //     state.error = action.payload;

    // })



    // //GetCourseCertificateData reducers

    // builder.addCase("GetCourseCertificateDataRequest", (state, action) => {

    //     state.loading = true

    // });



    // builder.addCase("GetCourseCertificateDataSuccess", (state, action) => {

    //     state.loading = false;

    //     state.error = {}

    //     state.courseCourseCertificateData = action.payload; // Store fetched time slots

    // })



    // builder.addCase('GetCourseCertificateDataFailure', (state, action) => {

    //     state.loading = false;

    //     state.error = action.payload;

    // })



    // //GetEnrollmentFKfromCertificateId reducers

    // builder.addCase("GetEnrollmentFKfromCertificateIdRequest", (state, action) => {

    //     state.loading = true

    // });



    // builder.addCase("GetEnrollmentFKfromCertificateIdSuccess", (state, action) => {

    //     state.loading = false;

    //     state.error = {}

    //     state.CertificateIdData = action.payload; // Store fetched time slots

    // })



    // builder.addCase('GetEnrollmentFKfromCertificateIdFailure', (state, action) => {

    //     state.loading = false;

    //     state.error = action.payload;

    // })



    //  //VerifyCerificateData reducers

    //  builder.addCase("VerifyCerificateDataRequest", (state, action) => {

    //     state.loading = true

    // });



    // builder.addCase("VerifyCerificateDataSuccess", (state, action) => {

    //     state.loading = false;

    //     state.error = {}

    //     state.certificateLinkData = action.payload; // Store fetched time slots

    // })



    // builder.addCase('VerifyCerificateDataFailure', (state, action) => {

    //     state.loading = false;

    //     state.error = action.payload;

    // })



    // builder.addCase("CreateInstituteCourseStep1Request", (state, action) => {

    //     state.loading = true

    // })



    // builder.addCase("CreateInstituteCourseStep1Success", (state, action) => {

    //     state.loading = false;

    //     state.error = {}

    //     state.InstituteCourseStep1Id = action.payload;

    // })

    // builder.addCase("CreateInstituteCourseStep1Failure", (state, action) => {

    //     state.loading = false;

    //     state.error = action.payload;

    // })



    // builder.addCase("CreateInstituteCourseStep2Request", (state, action) => {

    //     state.loading = true

    // })



    // builder.addCase("CreateInstituteCourseStep2Success", (state, action) => {

    //     state.loading = false;

    //     state.error = {}

    // })

    // builder.addCase("CreateInstituteCourseStep2Failure", (state, action) => {

    //     state.loading = false;

    //     state.error = action.payload;

    // })



    // builder.addCase("DeleteInstituteCourseRequest", (state, action) => {

    //     state.loading = true

    // })



    // builder.addCase("DeleteInstituteCourseSuccess", (state, action) => {

    //     state.loading = false;

    //     state.error = {}

    // })

    // builder.addCase("DeleteInstituteCourseFailure", (state, action) => {

    //     state.loading = false;

    //     state.error = action.payload;

    // })





    // builder.addCase("GetInstituteAutomaticTrainingHoursGenerationRequest", (state, action) => {

    //     state.loading = true

    // })



    // builder.addCase("GetInstituteAutomaticTrainingHoursGenerationSuccess", (state, action) => {

    //     state.loading = false;

    //     state.error = {};

    //     state.InstituteAutomaticTrainingHours = action.payload; // Store fetched time slots

    // })

    // builder.addCase("GetInstituteAutomaticTrainingHoursGenerationFailure", (state, action) => {

    //     state.loading = false;

    //     state.error = action.payload;

    // });
    






